module.exports = __webpack_public_path__ + "assets/2772fa250d538d9b7a8702fb6c50d195.js";